import { render, staticRenderFns } from "./print-layout.vue?vue&type=template&id=540bd670"
import script from "./print-layout.vue?vue&type=script&lang=js"
export * from "./print-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports